import React, { useState } from "react";
import LogoutButton from "./LogoutButton";
import { Link } from "react-router-dom";

const Navbar = ({ user, onLogout }) => {
  // State to control the hamburger menu for mobile and dropdown for desktop
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <nav className="bg-blue-800 p-4 shadow-md">
      <div className="flex justify-between items-center">
        <div className="text-white text-2xl font-bold">
          <Link to="/" className="hover:no-underline">
            PublicLink Insights
          </Link>
        </div>

        {/* Hamburger Icon for mobile view */}
        <div className="lg:hidden">
          <button
            onClick={toggleMenu}
            className="text-white focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>

        {/* Links for desktop view with Dropdown */}
        <div className="hidden lg:flex items-center relative">
          <Link
            to="/privacy-policy"
            className="text-white mr-4 hover:no-underline"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms-and-conditions"
            className="text-white mr-4 hover:no-underline"
          >
            Terms and Conditions
          </Link>

          {/* Dropdown Trigger */}
          <div className="relative">
            <button
              onClick={toggleDropdown}
              className="text-white flex items-center focus:outline-none"
            >
              <span className="mr-2">Welcome, {user?.name || "User"}</span>
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                ></path>
              </svg>
            </button>

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50">
                <button
                  onClick={onLogout}
                  className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:rounded-md"
                >
                  Logout
                </button>
                {/* <button
                  className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:rounded-md"
                >
                  Edit Profile (comming soon)
                </button> */}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Expanded menu for mobile view */}
      {isOpen && (
        <div className="lg:hidden mt-4">
          <Link
            to="/privacy-policy"
            className="block text-white py-2 hover:no-underline"
            onClick={toggleMenu}
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms-and-conditions"
            className="block text-white py-2 hover:no-underline"
            onClick={toggleMenu}
          >
            Terms and Conditions
          </Link>
          <div className="block text-white py-2 hover:no-underline">
            <LogoutButton onLogout={onLogout} />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
